import { MarkerAreaEvent, MarkerAreaRenderEvent, MarkerArea } from 'markerjs2';

type CallbackType = (dataUrl: string) => void;
type CloseCallbackType = () => void;
class ImageAnnotate {
    private static _instance: ImageAnnotate = new ImageAnnotate();

    constructor() {
        if (ImageAnnotate._instance) {
            throw new Error('Singleton class');
        }
        ImageAnnotate._instance = this;
    }

    public static get instance(): ImageAnnotate {
        return ImageAnnotate._instance;
    }

    showMarkerArea(
        targetId: string,
        translatedValue: string,
        renderCallback: CallbackType,
        closeCallback: CloseCallbackType,
    ) {
        const markerArea = new MarkerArea(document.getElementById(`img-${targetId}`) as HTMLImageElement | HTMLElement);

        // render image with annotation in base64
        markerArea.addEventListener('render', (event: MarkerAreaRenderEvent) => {
            renderCallback(event.dataUrl);
        });

        // make sure clicking close wasn't an accident
        markerArea.addEventListener('beforeclose', async (event: MarkerAreaEvent) => {
            closeCallback();
            if (!window.confirm(translatedValue)) {
                event.preventDefault();
            }
        });

        markerArea.settings.displayMode = 'popup';
        markerArea.settings.popupMargin = 80;
        markerArea.renderAtNaturalSize = true;
        markerArea.availableMarkerTypes = markerArea.ALL_MARKER_TYPES;
        markerArea.uiStyleSettings.zoomButtonVisible = true;
        markerArea.uiStyleSettings.zoomOutButtonVisible = true;
        markerArea.uiStyleSettings.zIndex = '1000000000';
        markerArea.uiStyleSettings.canvasBackgroundColor = '#333';
        markerArea.uiStyleSettings.toolbarBackgroundColor = '#105c9d';
        markerArea.uiStyleSettings.toolbarBackgroundHoverColor = '#00bbd1';
        markerArea.uiStyleSettings.okButtonColor = '#0f0';
        markerArea.show();
    }
}

export const imageAnnotate = ImageAnnotate.instance;
